import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-no-access-dialog',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatDividerModule,
  ],
  templateUrl: './no-access-dialog.component.html',
  styleUrls: ['./no-access-dialog.component.css', '../../styles/layout.css'],
})
export class NoAccessDialogComponent {
  // Variables
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;

  // Constructor
  constructor(
    public dialogRef: MatDialogRef<NoAccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
      confirmText: string;
      cancelText: string;
    }
  ) {
    // Obtener los datos del dialogo
    this.title = data.title;
    this.message = data.message;
    this.confirmText = data.confirmText;
    this.cancelText = data.cancelText;
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
